import React, { useState } from "react";

function Base64Encoder() {
    const [base64Input, setBase64Input] = useState("");
    const [base64Result, setBase64Result] = useState("");
    const [error, setError] = useState("");

    const encodeBase64 = () => {
        try {
            setError(""); // Limpiar el error anterior
            const encoded = btoa(base64Input);
            setBase64Result(encoded);
        } catch (e) {
            setError("Invalid text input.");
            setBase64Result("");
        }
    };

    return (
        <div className="tool">
            <h2>Base64 Encoder</h2>
            <input
                type="text"
                value={base64Input}
                onChange={(e) => setBase64Input(e.target.value)}
                placeholder="Enter text"
            />
            <button className="styled-button" onClick={encodeBase64}>Encode</button>
            <div className="result-container">
                {error && <p className="error-message">{error}</p>}
                <p>{base64Result}</p>
            </div>
        </div>
    );
}

export default Base64Encoder;
